import React, { useState } from 'react';
import { Button } from 'reactstrap';

const ALL_OPTIONS = [
  { label: 'Encuentra 24', value: 'Encuentra 24' },
  { label: 'Facebook', value: 'Facebook' },
  { label: '360', value: '360' },
];

type Props = {
  publishedIn?: string | null;
  publishedUrls?: { [key: string]: string };
  onSave?: (selected: string[], urls: { [key: string]: string }) => void;
  propertyId: string;
  handleSavePropertyField: (propertyId: string, field: string, value: string) => void;
};

const getInitialSelected = (publishedIn?: string | null) => {
  if (!publishedIn) return [];
  try {
    const arr = JSON.parse(publishedIn);
    if (Array.isArray(arr)) {
      return arr.map((item: { name: string }) => item.name);
    }
  } catch {
    return publishedIn.split(',').map(s => s.trim()).filter(Boolean);
  }
  return [];
};

const getInitialUrls = (publishedIn?: string | null) => {
  if (!publishedIn) return {};
  try {
    const arr = JSON.parse(publishedIn);
    if (Array.isArray(arr)) {
      const urls: { [key: string]: string } = {};
      arr.forEach((item: { name: string; url: string }) => {
        urls[item.name] = item.url || '';
      });
      return urls;
    }
  } catch {
    return {};
  }
  return {};
};

const PublishedInLinksCell: React.FC<Props> = ({
  publishedIn,
  publishedUrls = {},
  onSave,
  propertyId,
  handleSavePropertyField,
}) => {
  const initialSelected = getInitialSelected(publishedIn);
  const [selected, setSelected] = useState<string[]>(initialSelected);
  const [urls, setUrls] = useState<{ [key: string]: string }>(
    publishedUrls && Object.keys(publishedUrls).length ? publishedUrls : getInitialUrls(publishedIn)
  );
  const [hovered, setHovered] = useState(false);

  const handleSelect = (option: string) => {
    if (selected.includes(option)) {
      setSelected(selected.filter(s => s !== option));
      setUrls(urls => {
        const copy = { ...urls };
        delete copy[option];
        return copy;
      });
    } else {
      setSelected([...selected, option]);
    }
  };

  const handleUrlChange = (option: string, value: string) => {
    setUrls({ ...urls, [option]: value });
  };

  const handleSave = () => {
    const publishedInJson = selected.map(name => ({
      name,
      url: urls[name] || ''
    }));
    handleSavePropertyField(propertyId, 'published_in', JSON.stringify(publishedInJson));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {ALL_OPTIONS.map(opt => (
        <div key={opt.value} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <input
            type="checkbox"
            checked={selected.includes(opt.value)}
            onChange={() => handleSelect(opt.value)}
            id={`published-in-${opt.value}`}
          />
          <label htmlFor={`published-in-${opt.value}`} style={{ minWidth: 110 }}>
            {opt.label}
          </label>
          {selected.includes(opt.value) && (
            <input
              type="text"
              placeholder={`URL de ${opt.label}`}
              value={urls[opt.value] || ''}
              onChange={e => handleUrlChange(opt.value, e.target.value)}
              style={{
                minWidth: 180,
                border: '1px solid #ccc',
                borderRadius: 4,
                padding: '2px 8px',
                fontSize: 14,
              }}
            />
          )}
        </div>
      ))}
      <div style={{ position: 'relative', width: '100%' }}>
        <button
          type="button"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            borderRadius: 12,
            padding: 4,
            fontSize: 15,
            background: 'transparent',
            border: 'none',
            color: hovered ? '#5e72e4' : '#adb5bd',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 28,
            height: 28,
            cursor: 'pointer',
            outline: 'none',
            boxShadow: 'none',
          }}
          title="Guardar publicación"
          onClick={handleSave}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <i
            className="fas fa-save"
            style={{
              fontSize: 18,
              color: hovered ? '#5e72e4' : '#adb5bd',
              transition: 'color 0.2s',
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default PublishedInLinksCell;